export default __webpack_public_path__ + "static/media/leaderboard-banner.109b49a1.webp";